import { env, apimKey } from "../../../config";
import log from "../../../utils/log";

export default async function fetchServicesAsync() {
  const baseUrl = `https://apim-ikeasa.azure-api.net/GetServices/${env}/v2/`;
  const response = await fetch(baseUrl, {
    headers: {
      "Ocp-Apim-Subscription-Key": apimKey,
    },
  });

  if (response.status === 200) {
    // QueueId will be empty for measurement
    const json = await response.json();
    log("fetchServicesAsync", "response", json);

    return json.Services;
  }

  throw new Error(response.status);
}

/*
[
  {
    "AgentCode": "PL-KIT-O",
    "NAVItemNo": "999999991",
    "ServiceId": "1000001",
    "ServiceName_En": "Kitchen planning\r\n",
    "ServiceName_Ar": "تخطيط المطبخ\r\n",
    "Service_Desc_En": "Plan your dream kitchen online with the help of our team of professionals. Our team will connect remotely with you for the planning. The service fee is refundable after your kitchen purchase.\r\n",
    "Service_Desc_Ar": "خطط مطبخ أحلامك على موقعنا بالانترنت بمساعدة من فريقنا المختص. سيقوم فريقنا بالاتصال بك عن بعد للتخطيط. رسوم الخدمة قابلة  للاسترداد في حالة شراء المطبخ.\r\n",
    "Service_Fee": "150",
    "Service_Type": "Online",
    "Order_Type": "POS",
    "QueueId": "64aa8a7f-a616-44e8-806a-165e08d91192"
  },
  {
    "AgentCode": "PL-KIT-S",
    "NAVItemNo": "999999992\r\n",
    "ServiceId": "1000002",
    "ServiceName_En": "Kitchen planning\r\n",
    "ServiceName_Ar": "تخطيط المطبخ\r\n",
    "Service_Desc_En": "Plan your dream kitchen in-store with the help of our team of professionals. Our team will help you at IKEA store or Planning Studio. The service fee is refundable after your kitchen purchase.\r\n",
    "Service_Desc_Ar": "خطط مطبخ أحلامك في المعرض بمساعدة من فريقنا المختص. سيساعدك فريقنا في معرض ايكيا أو استوديو التخطيط. رسوم الخدمة قابلة للاسترداد في حالة شراء المطبخ.\r\n",
    "Service_Fee": "150",
    "Service_Type": "Store",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "CO-MEA",
    "NAVItemNo": "99999999",
    "ServiceId": "1000003",
    "ServiceName_En": "Kitchen Measurement",
    "ServiceName_Ar": "قياس المطبخ",
    "Service_Desc_En": "Those small details matter. So, we’ll pay you a visit at home or in your office to measure your space before the real planning begins. The service fee is refundable after your kitchen purchase.\r\n",
    "Service_Desc_Ar": "هناك بعض التفاصيل الصغيرة التي تعتبر مهمة بالنسبة لنا. لذلك، سنقوم بزيارة منزلك أو مكتبك لقياس مساحتك قبل بدء عملية التخطيط الفعلية. رسوم الخدمة قابلة للاسترداد في حالة شراء المطبخ.\r\n",
    "Service_Fee": "150",
    "Service_Type": "Home",
    "Order_Type": "CO"
  },
  {
    "AgentCode": "PL-BED-O",
    "NAVItemNo": "999999993",
    "ServiceId": "1000004",
    "ServiceName_En": "Wardrobe planning (PAX & PLATSA)\r\n",
    "ServiceName_Ar": "تخطيط دولاب الملابس (PAX & PLATSA)\r\n",
    "Service_Desc_En": "Plan the best storage solutions for your bedroom online with the help of our team of professionals. Our team will connect remotely with you for the planning.\r\n",
    "Service_Desc_Ar": "خطط أفضل حلول التخزين لغرفة نومك على موقعنا بالانترنت بمساعدة من فريقنا المختص. سيقوم فريقنا بالاتصال بك عن بعد للتخطيط.\r\n",
    "Service_Fee": "0",
    "Service_Type": "Online",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "PL-BED-S",
    "NAVItemNo": "999999994",
    "ServiceId": "1000005",
    "ServiceName_En": "Wardrobe planning (PAX & PLATSA)\r\n",
    "ServiceName_Ar": "تخطيط دولاب الملابس (PAX & PLATSA)\r\n",
    "Service_Desc_En": "Plan the best storage solutions for your bedroom in-store with the help of our team of professionals. Our team will help you at IKEA store or Planning Studio.\r\n",
    "Service_Desc_Ar": "خطط أفضل حلول التخزين لغرفة نومك في المعرض بمساعدة من فريقنا المختص. سيساعدك فريقنا في معرض ايكيا أو استوديو التخطيط.\r\n",
    "Service_Fee": "0",
    "Service_Type": "Store",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "PL-BATH-O",
    "NAVItemNo": "999999995",
    "ServiceId": "1000006",
    "ServiceName_En": "Bathroom planning\r\n",
    "ServiceName_Ar": "تخطيط الحمام",
    "Service_Desc_En": "Plan your dream Bathroom online with the help of our team of professionals. Our team will connect remotely with you for the planning.\r\n",
    "Service_Desc_Ar": "خطط حمام أحلامك على موقعنا بالانترنت بمساعدة من فريقنا المختص. سيقوم فريقنا بالاتصال بك عن بعد للتخطيط.\r\n",
    "Service_Fee": "0",
    "Service_Type": "Online",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "PL-BATH-S",
    "NAVItemNo": "999999996\r\n",
    "ServiceId": "1000007",
    "ServiceName_En": "Bathroom planning\r\n",
    "ServiceName_Ar": "تخطيط الحمام",
    "Service_Desc_En": "Plan your dream Bathroom in-store with the help of our team of professionals. Our team will help you at IKEA store or Planning Studio.\r\n",
    "Service_Desc_Ar": "خطط حمام أحلامك في المعرض بمساعدة من فريقنا المختص. سيساعدك فريقنا في معرض ايكيا أو استوديو التخطيط.\r\n",
    "Service_Fee": "0",
    "Service_Type": "Store",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "PL-LIV-O",
    "NAVItemNo": "999999997",
    "ServiceId": "1000008",
    "ServiceName_En": "Living room storage planning\r\n",
    "ServiceName_Ar": "تخطيط تخزين غرفة الجلوس\r\n",
    "Service_Desc_En": "Plan the best storage solutions for your living room online with the help of our team of professionals.\r\n",
    "Service_Desc_Ar": "خطط أفضل حلول التخزين لغرفة جلوسك على موقعنا بالانترنت بمساعدة من فريقنا المختص.\r\n",
    "Service_Fee": "0",
    "Service_Type": "Online",
    "Order_Type": "POS"
  },
  {
    "AgentCode": "PL-LIV-S",
    "NAVItemNo": "999999998",
    "ServiceId": "1000009",
    "ServiceName_En": "Living room storage planning\r\n",
    "ServiceName_Ar": "تخطيط تخزين غرفة الجلوس\r\n",
    "Service_Desc_En": "Plan the best storage solutions for your living room in-store with the help of our team of professionals. Our team will help you at IKEA store or Planning Studio.\r\n",
    "Service_Desc_Ar": "خطط أفضل حلول التخزين لغرفة جلوسك في المعرض بمساعدة من فريقنا المختص. سيساعدك فريقنا في معرض ايكيا أو استوديو التخطيط. \r\n",
    "Service_Fee": "0",
    "Service_Type": "Store",
    "Order_Type": "POS"
  }
]

*/
